import label from "@/lang/StaticLabels.js";

// PMRP Navbar  - بهای تمام شده -----------------------------------------------
let navItems = [
  {
    title: label.modules.pmrp,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PMRPDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PMRPCombinedBomList",
        label: label.menu.bom,
        metaLabel: label.page.bom,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPSystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.settings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSSettingTransactions",
        label: label.menu.settingTransactions,
        metaLabel: label.page.settingTransactions,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.production,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMRPAddProduction",
            label: label.menu.addProduction,
            metaLabel: label.page.addProduction,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPCombinedProduction",
            label: label.menu.productionList,
            metaLabel: label.page.production,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PMRPProductionDetailReports",
        label: label.menu.microProductionReport,
        metaLabel: label.page.microProductionReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPConsumablesReports",
        label: label.menu.consumablesReport,
        metaLabel: label.page.consumablesReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPProductionCostReports",
        label: label.menu.productionCostReport,
        metaLabel: label.page.productionCostReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
